module.exports = __webpack_public_path__ + "media/images/athletes/1678-c01d389ef81c6ef2a06f39685c7456b4.png";